import { render, staticRenderFns } from "./teacherInfo.vue?vue&type=template&id=54dfcf3a&scoped=true"
import script from "./teacherInfo.vue?vue&type=script&lang=js"
export * from "./teacherInfo.vue?vue&type=script&lang=js"
import style0 from "./teacherInfo.vue?vue&type=style&index=0&id=54dfcf3a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54dfcf3a",
  null
  
)

export default component.exports